const EurexQuickfoldersManager = () => import('@/modules/EurexQuickfoldersManager')

export default [
	{
		component: EurexQuickfoldersManager,
		name: 'quickfolders-manager',
		path: 'quickfolders-manager'
	}
]
